<template>
    <div class="mc-table">
        <el-table 
            ref="table"
            :data="option.data"
            :stripe="option.stripe.disable" 
            :border="option.border.disable" 
            :highlight-current-row="option.selected.disable"
            @current-change="option.selected.click"
            @selection-change="option.checkbox.click"
            :max-height="option.maxHeight"
            :sortable="sortable"
            align="center"
            style="width: 100%;text-align: left;"
            :cell-style="{textAlign: 'left'}"
            :header-cell-style="{textAlign: 'left'}"
        >
            <!-- checkbox -->
            <slot name="table-checkbox"></slot>
            <!-- 索引 -->
            <slot name="table-index">
                <el-table-column type="index" width="55"></el-table-column>
            </slot>
            <!-- 表结构 -->
            <slot name="table-components">
                <el-table-column v-for="(item, index) in (option.head)" :prop="item.prop" :key="index" :label="item.label" :width="item.width"></el-table-column>
            </slot>
            <!-- 操作栏 -->
            <el-table-column :label="option.operations.label" :width="_$operationsWidth" v-if="option.operations.disable" option="option.tOperations">
                <template slot-scope="scope">
                    <el-button
                        v-for="(item, index) in option.operations.items"
                        :key="index"
                        :size="item.size?item.size:'mini'"
                        :type="item.type?item.type:'default'"
                        :icon="item.icon?item.icon:' '"
                        :disabled="item.disabled"
                        @click="item.click(scope.$index, scope.row)"
                    >{{item.label}}</el-button>
                </template>
                </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { formatDate } from '../../libs/common';
    // const log = new Log("Components/mc-table");
    export default {
        name: 'mc-table',
        props: {
            tableOption: {
                type: Object,
            },
            sortable: Boolean,
        },
        data(){
            return {
                option: {
                    // 最大高度
                    maxHeight: '9999999',
                    // 单选
                    selected: {
                        disable: false,
                        click: ()=>{},
                    },
                    // 多选，checkbox
                    checkbox: {
                        disable: false,
                        click: ()=>{},
                    },
                    // 索引
                    index: {
                        disable: false,
                    },
                    // 斑马纹
                    stripe: {
                        disable: false,
                    },
                    // 边框
                    border: {
                        disable: false,
                    },
                    // 操作栏
                    operations: {
                        disable: false,
                        label: '',
                        items: [],
                    },
                    // 表头
                    head: [],
                    // 数据
                    data: [],
                },
            }
        },
        computed: {
            _$operationsWidth: function (){
                let rst = 15;
                this.option.operations.items.map(item=>{
                    if(item.label.length>0) {
                        rst = rst + (15*2 + item.label.length * 12 + 15);
                    } else {
                        rst = rst + (15*2 + 2 * 12 + 15);
                    }
                })
                return rst;
            },
        },
        methods: {
            formatDate,
            handleOption(){
                // log.debug("tableOption", this.tableOption);
                // log.debug("option", this.option);
                for(let i in this.tableOption) {
                    this.option[i] = this.tableOption[i];
                }
            },
        },
        mounted(){
            this.handleOption();
        },
        watch: {
            tableOption: {
                deep: true,
                handler: function(newVal, oldVal){
                    this.handleOption();
                },
            },
        },
    }
</script>

<style lang="less">
    .mc-table {
        width: 100%;
        padding: 0 10px;
        .current-row td{
            background-color: #409EFF !important;
            color: #fff;
        }
    }
    
</style>

